// Services
import purchaseService from "@/services/purchase";
import advanceService from "@/services/purchase/advance";
import catalogService from "@/services/catalog";
import warehouseService from "@/services/purchase/warehouse";
import { attachInvoiceToPurchaseOrder,fetchAdvancesByPurchase } from "@/services/purchase/purchaseOrder"


// Utils
import urlUtility from "@/utils/assetURL";
import { isImageURL } from "@/utils";

export default {
    data() {
    return {
      orderModal: false,
      dialogEditOrder: false,
      dialogPurchaseOrderInvoice: false,

      paginationInfo: null,
      propsToSearch: ["folio", "providerNumber"],
      tableHeaders: {
        folio: "Folio",
        status: "Estatus",
        completeProviderName: "Proveedor",
        addDate: "Fecha de creación",
        deliveryDate: "Fecha de entrega",
        resident: "Receptor",
      },
      tableHeadersAdvances: [
        {
          name: "Estatus",
          value: "advanceType",
          sort: true,
          numeric: false,
        },
        {
          name: "Cantidad",
          value: "amount",
          prefix: "$",
          sort: true,
          numeric: true,
        },
        {
          name: "Solicitante",
          value: "userRequesting",
          sort: true,
          numeric: false,
        },
        { name: "Fecha", value: "date", sort: false, numeric: false },
        {
          name: "Comentario",
          value: "comment",
          sort: false,
          numeric: false,
          role: ["GECA", "ATES", "ADM", "GEFI", "COMPRAS"],
        },
      ],
      tableActions: [
        {
          icon: "visibility",
          exe: this.view,
        },
        {
          icon: "receipt",
          ifUserCan: {
            add: "PurchaseRequisition/buyordertaxreceipt",
          },
          exe: this.openPurchaseOrderInvoicetDialog,
        },
        {
          icon: "edit",
          showIf: (item) => !!item.supplies.length,
          ifUserCan: {
            update_unit_price: "PurchaseRequisition/consolidatedsupply",
          },
          exe: this.openEditDialog,
        },
      ],
      tableActionsAdvances: [
        {
          icon: "picture_as_pdf",
          value: "pdf",
          exe: this.seeFile,
          tooltip: "Ver PDF",
        },
        {
          icon: "attachment",
          value: "xml",
          exe: this.seeFile,
          tooltip: "Ver xml",
        },
      ],
    }
  },
  
  methods: {
    fetchPurchaseOrders(fetchParams) {
      this.loading = true
      return purchaseService
        .fetchPurchaseOrders(fetchParams)
        .then(({ purchaseOrders, paginationInfo }) => {
          this.purchaseOrders = purchaseOrders;
          this.paginationInfo = paginationInfo;
        })
        .catch((err) => {
          this.paginationInfo = null;
          this.purchaseOrders = [];
        })
        .finally(() => (this.loading = false));
    },
    ordenModalHide() {
      if (!this.advanceLoading) {
        this.orderModal = false;
        this.toEditAdvance = {};
        this.currentOrder = {};
        this.currentOrderAdvances = {};
      }
    },
    view(element) {
      const { warehouseId } = this.fetchParams;
      const found = this.fetchedWarehouses.find(
        ({ id }) => id === +warehouseId
      );
      this.currentOrder = { ...element, warehouseName: found ? found.name : '' };
      if (this.$can("view", "PurchaseRequisition", "advances")) {
        this.fetchAdvances();
      } else {
        this.orderModal = true;
      }
    },
    fetchAdvances() {
      this.advanceLoading = true;
         return fetchAdvancesByPurchase(this.currentOrder.id)
        .then((res) => {
          this.currentOrderAdvances = res;
          this.orderModal = true;
        })
        .catch(this.$fireErrorResponse)
        .finally(() => (this.advanceLoading = false));
    },

    sendAdvance(payload, purchase) {
      this.advanceLoading = true;
      advanceService
        .createAdvanceByPurchase(payload, purchase)
        .then(() => {
          this.fetchAdvances();
          if(this.$refs.addAdvances) {
            this.$refs.addAdvances.cancelUpdate();
          }
          this.$successMessage({ title: "Anticipo solicitado" });
        })
        .catch(this.$fireErrorResponse)
        .finally(() => (this.advanceLoading = false));
    },

    updateAdvance(payload) {
      this.advanceLoading = true;
      advanceService
        .updateAdvanceByPurchase(payload, payload.id)
        .then(() => {
          this.fetchAdvances();
          this.toEditAdvance = {};
          if(this.$refs.addAdvances) {
            this.$refs.addAdvances.cancelUpdate();
          }
          this.$successMessage({ text: "Anticipo actualizado" });
        })
        .catch(this.$fireErrorResponse)
        .finally(() => (this.advanceLoading = false));
    },
    seeFile(file) {
      const cFile = urlUtility(file);
      if (!isImageURL(file)) {
        const win = window.open(cFile, "_blank");
        win.focus();
      }
    },
    editItem(item) {
      this.toEditAdvance = { ...item };
    },
    openEditDialog(item) {
      this.dialogEditOrder = true;
      this.currentOrder = item;
    },
    openPurchaseOrderInvoicetDialog(item) {
      this.dialogPurchaseOrderInvoice = true;
      this.currentOrder = item;
    },
    updateOrder(order) {
      const index = this.purchaseOrders.findIndex((o) => o.id === order.id);
      this.purchaseOrders.splice(index, 1, order);
      this.currentOrder = order;
    },
    changeStatusAdvances(toReject, toApprove) {
      this.advanceLoading = true;
      let p1 = () => [...toReject, ...toApprove].map((advance) => advanceService.changeAdvanceStatusReport(advance))
      let message1 = "";
      let message2 = "";
      if (toReject.length > 0) {
        message1 = `Antincipos rechazados: ${toReject.length}. `;
      }
      if (toApprove.length > 0) {
        message2 = `Anticipos aprovados: ${toApprove.length}.`;
      }
      Promise.all([...p1()])
        .then(() => {
          this.$successMessage({ text: message1 + message2 });
          return this.fetchAdvances();
        })
        .catch(this.$fireErrorResponse)
        .finally(() => (this.advanceLoading = false));
    },
    submitInvoices(invoices) {
      this.$loadingMessage();
      let invoiceRequests = invoices.map((invoice) => attachInvoiceToPurchaseOrder(this.currentOrder, invoice))
      return Promise.all([...invoiceRequests])
        .then((res) => {
          this.$successMessage({ title: 'Facturas enviadas' });
        })
        .catch(this.$fireErrorResponse)
        .finally(() => (this.dialogPurchaseOrderInvoice =  false));
    },
    providerSelected({id, providerTypeId}) {
      this.fetchParams.provider = id
      this.fetchParams.providerType = providerTypeId
    },
    removeProvider() {
      this.dummyParams.provider = null
      this.fetchParams.provider = null
      this.fetchParams.providerType = null
    }
  },
  mounted() {
    const { almacen: iwarehouseId = 3, folio: searchQuery } = this.$route.query;
    this.loading = true;
    this.fetchParams.warehouseId = iwarehouseId
    return Promise.all([
      warehouseService.fetchiWarehouse(),
      catalogService.fetch("provider_type"),
      catalogService.fetch("providers"),
      this.$http.get("user/type/revi/"),
      purchaseService.fetchPurchaseOrders({ ...this.fetchParams, iwarehouseId})
    ])
      .then(([warehouses, providerTypes, providers, revis, { purchaseOrders, paginationInfo }]) => {
        this.fetchedWarehouses = warehouses;
        this.providerTypes = providerTypes;
        this.searchQuery = searchQuery;
        this.$router.replace(
          {
            query: {
              almacen: this.fetchParams.warehouseId,
            },
          },
          () => {}
        );

        this.providers = providers.sort((a, b) => (a.slug < b.slug ? -1 : 1));
        this.revis = revis.data
          .map((revi) => {
            const { first_name, last_name, mothers_last_name } = revi.user;
            return {
              ...revi,
              fullName: `${first_name} ${last_name} ${mothers_last_name}`,
            };
          })
          .sort((a, b) => (a.user.first_name < b.user.first_name ? -1 : 1));
                 this.purchaseOrders = purchaseOrders;
          this.paginationInfo = paginationInfo;
      })
      .catch(this.$fireErrorResponse)
      .finally(() => {
        this.loading = false
        this.mountingFlag = true
      })
  },
}


// WEBPACK FOOTER //
// ./src/pages/Purchases/PurchaseOrderTracking/PurchaseOrderTrackingMixin.js